import { createAuthSessionRegistry, type AuthSession } from '@ngsos/portal-core';

const registry = createAuthSessionRegistry();

export function setAuthSession(session: AuthSession | null): void {
  registry.setAuthSession(session);
}

export function getAuthSession(): AuthSession {
  return registry.authSession;
}

export async function getAccessToken(): Promise<string | null> {
  return registry.authSession.getAccessToken();
}
